import { createSlice } from '@reduxjs/toolkit';
import FieldNames from '@/defaults/FieldNames.json';

export const initialState = {
    isWithinFiscalYear: true,
    isCreatingActualFeature: false,
    isCompleted: false,
    feature: null,
    project: null,
    plannedFeature: null,
    mode: 'read',
    isActual: false,
    isProject: false,
    isTreatment: false,
    visibleProjects: [],
    isEditingPostFireValue: false,
    postFireValueReference: null,
    storedPostFireValues: []
};

export const detailsSlice = createSlice({
    name: 'details',
    initialState,
    reducers: {
        setIsWithinFiscalYear: (state, action) => {
            state.isWithinFiscalYear = action.payload;
        },
        setIsCreatingActualFeature: (state, action) => {
            state.isCreatingActualFeature = action.payload;
        },
        setIsCompleted: (state, action) => {
            state.isCompleted = action.payload;
        },
        setFeature: (state, action) => {
            state.feature = action.payload;
        },
        setProject: (state, action) => {
            const project = action.payload;
            if (project === null) {
                state.project = null;
                return;
            }
            state.project = {
                ...project,
                geometry: project?.geometry?.toJSON?.() ?? project?.geometry,
            };
        },
        setPlannedFeature: (state, action) => {
            const plannedFeature = action.payload;
            if (plannedFeature === null) {
                state.plannedFeature = null;
                return;
            }
            state.plannedFeature = {
                ...plannedFeature,
                geometry: plannedFeature?.geometry?.toJSON?.() ?? plannedFeature?.geometry,
            };
        },
        updatePlannedFeatureAttributes: (state, action) => {
            if (state.plannedFeature) {
                state.plannedFeature.attributes = {
                    ...state.plannedFeature.attributes,
                    ...action.payload
                };
            }
        },
        setMode: (state, action) => {
            state.mode = action.payload;
        },
        setIsActual: (state, action) => {
            state.isActual = action.payload;
        },
        setIsProject: (state, action) => {
            state.isProject = action.payload;
        },
        setIsTreatment: (state, action) => {
            state.isTreatment = action.payload;
        },
        setVisibleProjects: (state, action) => {
            state.visibleProjects = action.payload;
        },
        setIsEditingPostFireValue: (state, action) => {
            state.isEditingPostFireValue = action.payload;
        },
        setPostFireValueReference: (state, action) => {
            state.postFireValueReference = action.payload;
        },
        setStoredPostFireValues: (state, action) => {
            state.storedPostFireValues = action.payload;
        },
        clearStoredPostFireValues: (state) => {
            state.storedPostFireValues = [];
        }
    }
});

export const {
    setIsWithinFiscalYear,
    setFeature,
    setProject,
    setIsCreatingActualFeature,
    setIsCompleted,
    setMode,
    setIsActual,
    setIsProject,
   setPlannedFeature, updatePlannedFeatureAttributes, setVisibleProjects,
    setIsEditingPostFireValue,
    // had issues with redux value being null so leaving this in so we can come back to it
    setPostFireValueReference,
    setStoredPostFireValues,
    clearStoredPostFireValues,
    setIsTreatment,
} = detailsSlice.actions;

export default detailsSlice.reducer;
